// pages/BankingPage.tsx
import React, { useState, useEffect, useCallback, useRef } from "react";
import UnitWhiteLabelApp from "../components/Banking/UnitWhiteLabelApp";
import PageWrapper           from "../components/UI/PageWrapper";
import { useUnitJwt } from "hooks/useUnitJwt";
import { useArtist } from "../contexts/ArtistContext";
import { trackEvent, BANKING_EVENTS } from "../services/analytics";
import { removeUnitCoLauncher, restoreUnitCoLauncher } from "../utils/unitcoLauncherCleanup";

const BankingPage: React.FC = () => {
  const { jwt, currentUserId } = useUnitJwt(true); // Always fetch on banking page
  const { currentArtistId } = useArtist();
  const [loaded, setLoaded] = useState(false);
  const lastArtistIdRef = useRef<number | null>(null);
  const hasReloadedRef = useRef<boolean>(false);

  // CRITICAL: Reload page when artist changes to force complete Unit.co widget re-initialization
  // This is necessary because Unit.co widget has internal networking/caching that doesn't reset on component unmount
  useEffect(() => {
    // Ensure launcher is visible whenever BankingPage effect runs
    restoreUnitCoLauncher();

    if (currentArtistId && currentArtistId !== lastArtistIdRef.current && lastArtistIdRef.current !== null) {
      console.log('[BankingPage] 🔄 Artist changed from', lastArtistIdRef.current, 'to', currentArtistId, '- reloading page to force widget re-initialization');
      
      // Prevent multiple reloads
      if (!hasReloadedRef.current) {
        hasReloadedRef.current = true;
        // Small delay to ensure state is updated
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
      return;
    }
    
    // Initialize on first mount
    if (currentArtistId && lastArtistIdRef.current === null) {
      lastArtistIdRef.current = currentArtistId;
      hasReloadedRef.current = false;
    }

    return () => {
      // Hide/remove launcher when leaving BankingPage
      removeUnitCoLauncher();
      // alert('BankingPage cleanup started');
    };
  }, [currentArtistId]);

  // Memoize onLoadComplete callback to prevent unnecessary re-renders
  const handleLoadComplete = useCallback(() => {
    setLoaded(true);
    // Track balance viewed when banking loads
    trackEvent(BANKING_EVENTS.BALANCE_VIEWED);
  }, []);

  return (
    <PageWrapper>
      <div className="mx-auto p-12 text-black rounded-lg profile-form flex flex-col gap-[2.875rem] min-h-screen">
        {/* <h1 className="profile-info-text-size">Banking</h1> */}
        {!jwt && <p>Loading…</p>}
        {jwt && !loaded && <p>Initializing app…</p>}
        {jwt && currentArtistId && (
          <UnitWhiteLabelApp
            jwtToken={jwt}
            currentUserId={currentUserId}
            currentArtistId={currentArtistId}
            onLoadComplete={handleLoadComplete}
          />
        )}
        
      </div>
    </PageWrapper>
  );
};

export default BankingPage;
